var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-3" }, [
    _c("h3", [_vm._v("25 Besar Penyakit Rawat Jalan")]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-3" }, [
      _c("h4", { staticClass: "mb-3" }, [_vm._v("Pencarian Data")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-3" }, [
        _c("div", { staticClass: "mb-3 row" }, [
          _c(
            "label",
            {
              staticClass: "col-sm-4 col-form-label text-end",
              attrs: { for: "year" },
            },
            [_vm._v("Bulan")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-8" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.year,
                  expression: "year",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "month", name: "year", id: "year" },
              domProps: { value: _vm.year },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.year = $event.target.value
                },
              },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-2" }, [
        _c("div", { staticClass: "mb-3" }, [
          _c("div", { staticClass: "col-sm-8 text-end" }, [
            _c(
              "button",
              { staticClass: "btn btn-primary", on: { click: _vm.getPel } },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _vm._v("\n                        Cari"),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "card mb-3" }, [
      _c("div", { staticClass: "card-header text-white bg-primary" }, [
        _vm._v("Data 25 Besar Penyakit Rawat Jalan"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { attrs: { id: "table" } }, [
          _c(
            "table",
            { staticClass: "table table-bordered" },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._l(_vm.data_pel, function (item, index) {
                return _c("tbody", { key: index }, [
                  _c("tr", [
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.NomorKodeRS) +
                          "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.NamaRS) +
                          "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.KotaKab) +
                          "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.bulanString(_vm.bulan)) +
                          "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.tahun) +
                          "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(item.KdICD) +
                          "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(item.Diagnosa) +
                          "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(item.jumlah_pria) +
                          "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(item.jumlah_wanita) +
                          "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(item.pasien_meninggal) +
                          "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(item.pasien_hidup) +
                          "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(item.total) +
                          "\n                            "
                      ),
                    ]),
                  ]),
                ])
              }),
            ],
            2
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c(
          "th",
          {
            staticStyle: { "vertical-align": "top", "text-align": "center" },
            attrs: { rowspan: "2" },
          },
          [_vm._v("Kode RS")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: { "vertical-align": "top", "text-align": "center" },
            attrs: { rowspan: "2" },
          },
          [_vm._v("Nama RS")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: { "vertical-align": "top", "text-align": "center" },
            attrs: { rowspan: "2" },
          },
          [_vm._v("Kab/Kota")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: { "vertical-align": "top", "text-align": "center" },
            attrs: { rowspan: "2" },
          },
          [_vm._v("Bulan")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: { "vertical-align": "top", "text-align": "center" },
            attrs: { rowspan: "2" },
          },
          [_vm._v("Tahun")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: { "vertical-align": "top", "text-align": "center" },
            attrs: { rowspan: "2" },
          },
          [_vm._v("Kode ICD")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: { "vertical-align": "top", "text-align": "center" },
            attrs: { rowspan: "2" },
          },
          [_vm._v("Diagnosa")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: { "vertical-align": "top", "text-align": "center" },
            attrs: { colspan: "2" },
          },
          [_vm._v("Pasien Keluar Hidup & Mati")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: { "vertical-align": "top", "text-align": "center" },
            attrs: { rowspan: "2" },
          },
          [_vm._v("Jumlah Pasien Keluar Hidup")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: { "vertical-align": "top", "text-align": "center" },
            attrs: { rowspan: "2" },
          },
          [_vm._v("Jumlah Pasien Keluar Mati")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: { "vertical-align": "top", "text-align": "center" },
            attrs: { rowspan: "2" },
          },
          [_vm._v("Total")]
        ),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("th", [_vm._v("LK")]),
        _vm._v(" "),
        _c("th", [_vm._v("LP")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }